module.exports = __webpack_public_path__ + "img/exhibition-3-title@2x.11757396.png";